module.exports = __webpack_public_path__ + "static/media/rect2.a0b88cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/rect2.png
// module id = 1177
// module chunks = 0